import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import ThreePanels from "@/components/site/ThreePanels";
import Expertises from "@/components/site/Expertises";
import Formalites from "@/components/site/Formalites";
import Equipe from "@/components/site/Equipe";
import AvisClients from "@/components/site/AvisClients";
import AuditForm from "@/components/site/AuditForm";
import Footer from "@/components/site/Footer";
import { SeoHome } from "@/components/site/Seo";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <SeoHome />
      <Nav />
      <Hero />
      <ThreePanels />
      <Expertises />
      <Formalites />
      <Equipe />
      <AvisClients />
      <AuditForm />
      <Footer />
    </main>
  );
}
